import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
export var getDesignTeam = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query DesignTeam {\n    designTeam {\n      description\n      designteam_id\n      first_name\n      image\n      image_hover\n      image_flip\n      last_name\n      position\n      sort\n    }\n  }\n"])));
export default {
  getDesignTeam: getDesignTeam
};